import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Response } from '@angular/http';
import {of as observableOf,  Observable } from 'rxjs';

import { User } from "../models/user.model";
import { Login } from "../models/login.model";
import { Token} from "../models/token.model";
import { isPlatformBrowser } from '@angular/common';
import { Menu } from '../models/menu.model';
import { MenuItem } from '../models/menu-item';
import { IQueryResult } from '../base/interfaces/IQueryResult';
import { map, share } from 'rxjs/operators';

@Injectable()
export class MenuService {
  apps:Menu[];
  observable;

  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') private rootUrl: string
  ) { }

  get Apps():Menu[]{
    return this.apps;
  }

  Get(id:string){
    return this.http.get<Menu[]>(this.rootUrl + 'Menu/'+id);
  }
  Post(menu:Menu){
    return this.http.post<Menu>(this.rootUrl + 'Menu',menu);
  }
  Put(menu:Menu){
    return this.http.put<Menu>(this.rootUrl + 'Menu',menu);
  }
  GetChildren(idParent?:string): Observable<IQueryResult<Menu>>{
    const url = `${this.rootUrl}/Menu/children${idParent?'/'+idParent:''}`;
    return this.http.get<IQueryResult<Menu>>(url);
  }
  GetDynamicItems(idParent?:string): Observable<IQueryResult<Menu>>{
    const url = `${this.rootUrl}/Menu/dynamic${idParent?'/'+idParent:''}`;
    return this.http.get<IQueryResult<Menu>>(url);
  }
  GetApps(reload?:boolean):Observable<Menu[]>{
    if (!reload && this.apps) {
      return observableOf(this.apps);
    } else if (!reload && this.observable) {
      return this.observable;
    } else {
      this.observable = this.http.get(`${this.rootUrl}/Menu/children`, {
        observe: 'response'
      }).pipe(
      map(response =>  {
        this.observable = null;
        if (response.status === 400) {
          return 'Request failed.';
        } else if (response.status === 200) {
          this.apps = (<IQueryResult<Menu>>response.body).payload;
          return this.apps;
        }
      }),
      share(),);
      return this.observable;
    }
  }  
}
